import { UploadedGuestData, UploadedStructureData } from '@features/add-participants-modal/with-excel';
import { StatisticsUploadedUsers } from './StatisticsUploadedUsers';
import { ErrorsUploadedUsers } from './ErrorsUploadedUsers';
import { Button } from '@shared/ui/kit';
import { FC, useState } from 'react';

interface ModalProps {
  uploadedData: UploadedStructureData | UploadedGuestData;
  onBack: () => void;
  setShowModal: (value: boolean) => void;
}

export const ModalSegment: FC<ModalProps> = ({ uploadedData, onBack, setShowModal }) => {
  const [showErrorUsers, setShowErrorUsers] = useState(false);

  const handleGoBack = () => {
    if (showErrorUsers) {
      setShowErrorUsers(false);
    } else {
      setShowModal(false);
      onBack();
    }
  };

  return (
    <>
      {!showErrorUsers ? (
        <StatisticsUploadedUsers uploadedData={uploadedData} onShowErrors={() => setShowErrorUsers(true)} />
      ) : (
        <ErrorsUploadedUsers uploadedData={uploadedData} />
      )}

      <Button
        size="small"
        variant="secondary"
        onClick={handleGoBack}
        settings={{
          width: '96px',
          fontFamily: 'DIN-2014_Regular',
          position: 'absolute',
          bottom: '16px',
          left: '24px',
        }}
      >
        <p>Назад</p>
      </Button>
    </>
  );
};
